export default "__VITE_ASSET__DeM7GKhn__"